/**
 * The result of a successful KeyOperation.
 *
 * @see {KeyOperation}
 * @see https://msdn.microsoft.com/en-us/library/dn302313(v=vs.85).aspx
 */
export interface Key {
  readonly algorithm: string;
  readonly extractable: boolean;
  readonly keyUsage: Array<string>;
  readonly type: string;
}
